import { WorkModel } from '@Entities/work/work'

export const createUpdatingWorkDraft = <T extends { localId?: number }>(
    work: WorkModel,
    key: keyof WorkModel,
    data: T
): WorkModel => {
    const dataArr: any[] = work[key] as any
    const lastLocalId = dataArr.length ? Number(dataArr[dataArr.length - 1].localId) : 0

    return {
        ...work,
        [key]: [
            ...(dataArr as any),
            {
                ...data,
                localId: lastLocalId + 1,
            },
        ],
    }
}

export const stringLengthCreator = (length: number) => {
    let value = ''
    for (let n = 0; n < length; n++) {
        value += 'x'
    }
    return value
}
